import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleNewsletterSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setSubmitStatus('success');
      setEmail('');
      setTimeout(() => setSubmitStatus('idle'), 3000);
      return;
    }

    try {
      const res = await fetch('http://thinkbu.com/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (res.ok && parsed?.code === 'OK') {
        setSubmitStatus('success');
        setEmail('');
        setTimeout(() => setSubmitStatus('idle'), 3000);
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || '提交失败，请稍后再试';
        if (serverMsg.includes('spam')) {
          setSubmitStatus('success');
          setEmail('');
        } else {
          setFormError(serverMsg);
          setSubmitStatus('error');
        }
      }
    } catch {
      setFormError('网络错误，请检查网络后重试');
      setSubmitStatus('error');
    }
  };

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row justify-between gap-10 mb-14">
            {/* Brand */}
            <div className="lg:max-w-xs">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-book-open-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  土豪漫画
                </span>
              </Link>
              <p className="text-foreground-400 text-sm leading-relaxed">
                土豪漫画网提供免费漫画下拉式浏览和高清韩漫人气榜，您可以在线观看韩国漫画，轻松追踪热门趋势并享受视觉上的精彩盛宴。
              </p>
            </div>

            {/* Links */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
              <div>
                <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                  <a href="#quick-nav" className="hover:text-primary-300 transition-colors">快速导航</a>
                </h4>
                <ul className="space-y-2.5">
                  <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">首页</Link></li>
                  <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">韩漫排行</Link></li>
                  <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">免费漫画</Link></li>
                  <li><Link to="/category/all" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">漫画分类</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                  <a href="#about-nav" className="hover:text-primary-300 transition-colors">关于我们</a>
                </h4>
                <ul className="space-y-2.5">
                  <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">品牌介绍</Link></li>
                  <li><a href="#testimonials" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">用户口碑</a></li>
                  <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">联系我们</Link></li>
                </ul>
              </div>
              <div>
                <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                  <a href="#category-nav" className="hover:text-primary-300 transition-colors">热门分类</a>
                </h4>
                <ul className="space-y-2.5">
                  <li><Link to="/category/korean-romance" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">韩漫恋爱</Link></li>
                  <li><Link to="/category/korean-action" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">热血格斗</Link></li>
                  <li><Link to="/category/korean-fantasy" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">奇幻冒险</Link></li>
                  <li><Link to="/category/korean-thriller" className="text-sm text-foreground-400 hover:text-background-100 transition-colors cursor-pointer">悬疑惊悚</Link></li>
                </ul>
              </div>
            </div>

            {/* Newsletter */}
            <div className="lg:max-w-xs">
              <h4 className="font-heading text-sm font-semibold text-background-100 mb-4">
                订阅更新
              </h4>
              <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
                订阅我们的更新通知，第一时间获取最新漫画上线消息
              </p>
              <form
                className="flex gap-2"
                id="newsletter-form"
               
                onSubmit={handleNewsletterSubmit}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="输入邮箱地址"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 px-4 py-2.5 rounded-lg bg-foreground-800 border border-foreground-700 text-background-100 text-sm placeholder-foreground-500 focus:outline-none focus:border-primary-500 transition-colors"
                  required
                />
                <button
                  type="submit"
                  className="px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-send-plane-line"></i>
                </button>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </form>
              {submitStatus === 'success' && (
                <p className="mt-3 text-sm text-accent-400">订阅成功！感谢您的关注。</p>
              )}
              {submitStatus === 'error' && (
                <p className="mt-3 text-sm text-red-400">{formError}</p>
              )}
            </div>
          </div>

          {/* Bottom */}
          <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-foreground-500">
              <span className="font-heading text-base">&copy;</span> 2026 土豪漫画网 All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-sm text-foreground-500 hover:text-background-100 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-background-100 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-sm text-foreground-500 hover:text-background-100 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}